export default class QueriesController {
  #api;
  #paths;
  constructor(requestService, paths) {
    this.#api = requestService;
    this.#paths = paths;
  }

  async fetchTaskPriorities() {
    try {
      const path = this.#paths.tasks.taskPriorities;
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      throw new Error('[Query]: Sorry, Unable to obtain task priorities.');
    }
  }
  async fetchAllChildTasks({ childId, filter }) {
    try {
      const path = this.#paths.tasks.allChildTasks(childId, filter);
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      throw new Error("[Query]: Sorry, Unable to obtain child's tasks.");
    }
  }
  async fetchProjects({ childId }) {
    try {
      const path = this.#paths.myProjects.allProjects(childId);
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      throw new Error("[Query]: Sorry, Unable to obtain child's all projects.");
    }
  }
  async fetchTaskPriorities() {
    try {
      const path = this.#paths.tasks.taskPriorities;
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      throw new Error('[Query]: Sorry, Unable to obtain task priorities.');
    }
  }
  async fetchProjectInfo({ projectId }) {
    try {
      const path = this.#paths.myProjects.projectInfo(projectId);
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      throw new Error('[Query]: Sorry, Unable to obtain project info.');
    }
  }
  async fetchTaskInfo({ taskId }) {
    try {
      const path = this.#paths.tasks.taskInfoOrEdit(taskId);
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      throw new Error('[Query]: Sorry, Unable to obtain task info.');
    }
  }
  async fetchTaskTypes() {
    try {
      const path = this.#paths.tasks.taskTypes;
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      throw new Error('[Query]: Sorry, Unable to obtain task types.');
    }
  }
  async fetchTaskRepeatOptions() {
    try {
      const path = this.#paths.tasks.taskRepeatOptions;
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      throw new Error('[Query]: Sorry, Unable to obtain task repeat options.');
    }
  }
  async fetchTaskTypesNotifications() {
    try {
      const path = this.#paths.tasks.taskTypesNotifications;
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      throw new Error('[Query]: Sorry, Unable to obtain types notifications for tasks.');
    }
  }
  async fetchCalendar({ childId, queryParams }) {
    try {
      const path = this.#paths.calendar.getCalendar(childId, queryParams);
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      throw new Error('[Query]: Sorry, Unable to obtain calendar.');
    }
  }

  async fetchAllTaskTimers() {
    try {
      const path = this.#paths.tasks.getAllTaskTimers;
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      throw new Error('[Query]: Sorry, Unable to obtain task timers.');
    }
  }
}
